import { gql } from 'apollo-angular'

export const GET_EDITIONS = gql`
  query {
    Editions(select: true) {
      docs {
        id
        edition_version
        title
        volume
        year
        magazine {
          id
        }
        slug
      }
    }
  }
`
